import { withNamespaces } from "react-i18next";
import emailjs from "@emailjs/browser";
import styled from 'styled-components';

import { languages } from "../../constants/languages";

import { Button } from "../styles/Design";
import { useRef, useState } from "react";
import { Input, Select, TextArea } from "../styles/Form.styled";
import { message, Modal } from "antd";



const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 32px;
  background: rgba(255, 255, 255, 0.49);
  border-radius: 0.5rem;
  width:476px;
`;




const HeaderForm = ({ t, theme }) => {
  const {
    REACT_APP_EMAILJS_SERVICE_ID,
    REACT_APP_EMAILJS_TEMPLATE_ID,
    REACT_APP_EMAILJS_USER_ID,
  } = process.env;

  emailjs.init(REACT_APP_EMAILJS_USER_ID);

  const formRef = useRef();
  const [emailForm, setEmailForm] = useState({
    name: "",
    email: "",
    serviceType: "Graduation research",
    translateFrom: "Translate From",
    translateTo: "Translate To",
  });

  const [showModal, setShowModal] = useState({
    show: false,
    status: "success",
  });

  const services = [
    "Graduation research",
    "Research paper",
    "Legal translation",
    "Scientific research",
    "Content writer",
    "Voice over",
    "Blogger",
  ];

  const showResult = () => {
    if (showModal.status === "success") {
      return Modal.success({
        content: t("sections.header.form.success"),
      });
    } else {
      return Modal.error({
        content: t("sections.header.form.error"),
      });
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setShowModal(false);

    message.loading(t("sections.header.form.loading"), 2.5);
    try {
      const { text } = await emailjs.sendForm(
        REACT_APP_EMAILJS_SERVICE_ID,
        REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target
      );
      if (text === "OK") {
        setShowModal({ show: true, status: "success" });
        return showResult();
      }
    } catch (error) {
      setShowModal({ show: true, status: "error" });
      return showResult();
    }
  };
  console.log(emailForm)
  return (
    <Form name="translate-form" onSubmit={sendEmail} ref={formRef}>
      <Input
        placeholder={t("translateForm.labels.name")}
        size="large"
        value={emailForm.name}
        onChange={(e) =>
          setEmailForm({ ...emailForm, name: e.target.value })
        }
        name="name"
      />

      <Input
        placeholder={t("translateForm.labels.email")}
        size="large"
        value={emailForm.email}
        onChange={(e) =>
          setEmailForm({ ...emailForm, email: e.target.value })
        }
        name="email"
      />

      <Select
        name="serviceType"
        onChange={(e) => setEmailForm({ ...emailForm, serviceType: e })}
      >
        <option value="holder" disabled selected>
          {t("translateForm.labels.serviceType")}
        </option>
        {services.map((service, index) => (
          <option value={service}>
            {t(`translateForm.selectOptions.services.${index}`)}
          </option>
        ))}
      </Select>

      <Select
        onChange={(e) => setEmailForm({ ...emailForm, translateFrom: e })}
        name="translateFrom"
      >
        <option value="holder" disabled selected>
          {t("translateForm.placeholders.translateForm")}
        </option>
        {languages.map((lang) => (
          <option value={lang}>
            {t(`translateForm.selectOptions.languages.${lang}`)}
          </option>
        ))}
      </Select>

      <Select
        onChange={(e) => setEmailForm({ ...emailForm, translateTo: e })}
        name="translateTo"
        required
      >
        <option value="holder" disabled selected>
          {t("translateForm.placeholders.translateTo")}
        </option>
        {languages.map((lang) => (
          <option value={lang}>
            {t(`translateForm.selectOptions.languages.${lang}`)}
          </option>
        ))}
      </Select>
      <TextArea placeholder="Description" onChange={(e) => setEmailForm({ ...emailForm, description: e.target.value })} />

      <Button width="100%" htmlType="submit" type="secondary">
        {t("translateForm.buttons.submit")}
      </Button>
    </Form>
  );
};

export default withNamespaces()(HeaderForm);
